import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready || user === null)
    return (
      <div className="h-screen flex items-center justify-center text-slate-400">
        <Loader2 className="animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "driver" ? "/driver" : "/dashboard"} replace />;
  }
  return children;
}
